import React, { Component} from "react";
import {Link, withRouter} from "react-router-dom";
import {
	bazaar,
	googleplay,
	appstore,
	footerPhone,
	phone,
	fax,
	support
} from "../images";

class Footer extends Component{
	render () {
		return(
			<div className="footer">
				<footer className="container direction-rtl">
					<div className="row pt-5">
						<div className="col-3 text-right">
							<h2 className="font-weight-bold">خانه</h2>
							<ul className="list-unstyled">
								<li className="mb-2">
									<a href={"http://mapsa.ir/"} target={"_blank"}>معرفی اپلیکشن</a>
								</li>
								<li className="mb-2">
									<Link to="/">راهنما اپلیکشن</Link>
								</li>
								<li className="mb-2">
									<Link to="/faq">پرسش های متداول</Link>
								</li>
								<li className="mb-2">
									<Link to="/aboutus">درباره ما</Link>
								</li>
							</ul>
						</div>
						<div className="col-3 text-right">
							<h2 className="font-weight-bold">راهنما</h2>
							<ul className="list-unstyled">
								<Link to={"/payment-and-purchase"}> <li className="mb-2">پرداخت و خرید</li> </Link>
								<Link to="/receive"> <li className="mb-2">دریافت‌ها</li> </Link>
								<Link to="/calender"> <li className="mb-2">تقویم</li> </Link>
								<Link to="/reports"> <li className="mb-2">گزارش‌ها</li> </Link>
								<Link to="/functions"> <li className="mb-2">کارکرد ها</li> </Link>
								<Link to="/setting"> <li className="mb-2">تنظیمات</li> </Link>
							</ul>
						</div>
						<div className="col-1"></div>
						<div className="col-5 text-right pl-0 pr-0">
							<h2 className="font-weight-bold">ارتباط با ما</h2>
							<div className="row footer-border-bottom pb-3">
								<div className="list-inline ml-3">
									<div className="footer-text-color"><img className="footer-icon ml-3 mr-2" src={phone} alt="۰۵۰۹۹۵۶۲"/>۰۵۰&nbsp;&nbsp;&nbsp;&nbsp;۹۹۵&nbsp;&nbsp;۶۲</div>
									<div className="footer-text-color"><img className="footer-icon ml-3 mr-2" src={fax} alt=""/>۶۳۷&nbsp;&nbsp;۵۵۷&nbsp;&nbsp;۶۶</div>
								</div>
								<div className="mr-3">
									<div className="footer-text-color">آدرس: تهران - طرشت - خیابان تیموری</div>
									<div className="footer-text-color">- نبش کوچه برومند - پلاک ۲ - واحد ۸</div>
								</div>
							</div>
							<div className="row pt-3 pl-4 pr-2">
								<div className="col-8 ml-3 footer-subscribe pr-0 pl-0">
									برای اطلاع از آخرین اخبار و به روز
									رسانی ها در کانال تلگرام ما عضو شوید
								</div>
								<div className="col-3 pr-0 pl-0">
									<a href="//telegram.me/Mapsa_ir" target={"_blank"}>
										<button className="footer-button">عضویت</button>
									</a>
								</div>
							</div>
						</div>
					</div>
				</footer>
				<footer className="smart-phone-footer pt-4">
					<div className="smart-phone-footer-container direction-rtl">
						<div className="ml-0 pl-0 pr-4 font-weight-bold pull-right">
							<img className="footer-icon ml-2" src={ support } alt="تماس با پشتیبانی فنی"/>
							پشتیبانی فنی
						</div>
						<div className="p-0 pl-4 pt-1 pull-left">
							۰۲۱&nbsp;۶۲&nbsp;۹۹۵&nbsp;۰۵۰
							<img className="footer-phone-icon mr-2" src={footerPhone} alt=""/>
						</div>
					</div>
				</footer>
				<div className="direction-rtl d-inline-block container-fluid">
					<div className="pt-4 pull-right footer-copyright footer-last-items">
						&copy;<span>تمامی حقوق این وب سایت متعلق به مپسا می‌باشد</span>
					</div>
					<div className="pull-left footer-last-items">
						<img className={"footer-social-networks"} src={appstore} alt="اپ استور"/>
						<a href="http://play.google.com/store/apps/details?id=com.domus.safariar.domus" target={"_blank"}>
							<img className={"footer-social-networks"} src={googleplay} alt="گوگل پلی"/>
						</a>
						<a href="http://cafebazaar.ir/app/com.domus.safariar.domus/?l=fa" target={"_blank"}>
							<img className={"footer-social-networks"} src={bazaar} alt="کافه بازار"/>
						</a>
					</div>
				</div>
			</div>

		);
	}
}

export default withRouter(Footer);